import { Injectable, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { SharedService } from './shared.service';
import { AppMessage, MESSAGE_TYPE_CHANGE_LOCALE, MESSAGE_TYPE_CUSTOM_TOKEN, MESSAGE_TYPE_CUSTOM_TOKEN_ACK } from '../models/message.model';
import { AuthService } from '../modules/auth';
import { lastValueFrom } from 'rxjs';
import { DataService } from './data.service';
import { Club } from '../models/club.model';
import { TranslateService } from '@ngx-translate/core';
import { Team } from '../models/team.model';

@Injectable({
    providedIn: 'root'
})
export class MessageService implements OnDestroy {

    constructor(private auth: AuthService, 
        private shared: SharedService, 
        private data: DataService, 
        private translate: TranslateService,
        private router: Router
    ) {        
        window.addEventListener('message', this.listener);
        /* Query param para UBIKO SYNC */
        this.checkCustomTokenFromQuery();
    }

    private listener = (event: MessageEvent) => {
        const message = event as MessageEvent;                
        const appMessage = message.data as AppMessage;  

        if(appMessage.source == 'ubiko-tech') {
            if(appMessage?.type === MESSAGE_TYPE_CUSTOM_TOKEN) {
                console.log('Auth : custom token message received', message);
                if(appMessage?.data?.token) {
                    this.customToken(appMessage.data.token);
                }
            } else if(appMessage?.type === MESSAGE_TYPE_CHANGE_LOCALE) {
                console.log('Auth : change locale message received', message);
                this.locale(appMessage);
            } 
        }  
    };

    private async checkCustomTokenFromQuery() {
        const url = new URL(window.location.href);
        const customToken = url.searchParams.get(MESSAGE_TYPE_CUSTOM_TOKEN);
        if (customToken) {
            try {
                console.log('Auth : custom token found. Authenticating...', customToken);
                this.customToken(customToken, false);                
            } catch (error) {
                console.error('Auth : error during custom token auth:', error);
            }
        }
    }

    private locale(appMessage: AppMessage) {
        if(appMessage.data?.locale) {
            this.translate.use(appMessage.data.locale);
            this.shared.setLanguage(appMessage.data.locale);
        }        
    }

    private async customToken(token: string, redirect: boolean = true) {
        try {            

            let responseMessage: AppMessage = {
                source: 'ubiko-admin',
                type: MESSAGE_TYPE_CUSTOM_TOKEN_ACK,
                data: {}
            };

            if(token) {
                const user = await this.auth.signInWithCustomToken(token);
                if(user) {    
                    const userData = await this.auth.getUserData(user);
                    if(userData?.club) {    
                        console.log('Auth : user data', userData);   
                        this.auth.storageUserData(userData); 
                        localStorage.setItem('app-user-uid', user.uid);
                        this.shared.clearStorageForOtherUsers();  
                        this.shared.clearSwitchIdentity();

                        const clubResponse = await lastValueFrom(this.data.load('clubs/' + userData?.club));
                        if(clubResponse?.club) {  
                            const club = clubResponse.club as Club;
                            console.log('Auth : club', club.id);                                     
                            this.shared.setCurrentClubObject(club);    
                            if(club.language) {
                                this.shared.setLanguage(club.language);
                                this.translate.currentLang = club.language;
                            }
                            let id_team;
                            let team: Team = this.shared.currentTeam;    
                            if(team) {
                                id_team = team.id;
                            }
                            let teams: string[] = (userData && userData.teams) ? Object.keys(userData.teams) : []; 
                            if(id_team || (teams && teams.length == 1)) {      
                                const teamResponse = await lastValueFrom(this.data.load('teams/' + (id_team || teams[0])));                                       
                                if(teamResponse?.team) {   
                                    const team = teamResponse?.team as Team;
                                    console.log('Auth : team', team?.id);   
                                    responseMessage.data.id_team = team?.id;
                                    responseMessage.data.id_squad = team?.active_squad?.id;
                                    this.shared.setCurrentTeam(team, false);      
                                    if(redirect) {
                                        this.router.navigateByUrl('/');
                                    }
                                }
                                else {
                                    this.shared.setCurrentTeam(undefined, false);
                                    if(redirect) {
                                        this.router.navigate(['teams']);        
                                    }                  
                                }                 
                            }    
                            else {                                       
                                if(redirect) {
                                    this.router.navigate(['teams']);        
                                } 
                            } 
                        }
                        else {
                            responseMessage.errors = [
                                this.translate.instant('login.error.club')
                            ];
                        }                               
                    }  
                    else {
                        responseMessage.errors = [
                            this.translate.instant('login.error.club')
                        ];
                    } 
                }
                else {
                    responseMessage.errors = [
                        this.translate.instant('login.error.401')
                    ];
                }
            }
            this.shared.sendPostMessage(responseMessage);
            console.log('Auth : custom token response', responseMessage);

        } catch (error) {
            console.log('Auth : custom token error', error);
            this.shared.sendPostMessage({
                source: 'ubiko-admin',
                type: MESSAGE_TYPE_CUSTOM_TOKEN_ACK,
                data: {},
                errors: [error as string]
            });
        }
    }

    ngOnDestroy(): void {
        window.removeEventListener('message', this.listener);
    }
}